<template>
  <div class="w-full flex">
    <div
      v-if="!tenantPermission('display-auth-image')"
      class="mt-8 md:flex hidden absolute z-0 left-20"
    >
      <symmetral-icon />
    </div>
    <div class="flex w-full justify-center pt-4 lg:pt-0">
      <div
        class="flex justify-center min-w-full max-w-full min-h-screen max-h-screen"
      >
        <div
          v-if="breakpoints.w > 1050 && tenantPermission('display-auth-image')"
          class="min-h-screen w-1/2"
        >
          <app-auth-image class="min-h-screen w-full" />
        </div>
        <div
          class="flex justify-center align-center shadow-sm min-h-screen w-full sm:w-4/5 md:w-1/2 pt-12 md:px-12 px-6 p-1"
          :class="tenantPermission('display-auth-image') ? 'border-2' : ''"
        >
          <div
            class="flex flex-col align-center justify-center h-full w-full lg:w-8/12 xl:7/12"
          >
            <span class="font-bold text-center mb-2 text-xl"
              >Forgot Password</span
            >
            <span class="text-left mb-4 mt-2 text-md text-grey-8">
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </span>
            <el-form
              @keyup.enter.native="
                validateForgotPasswordForm('forgotPasswordForm')
              "
              label-position="top"
              class="my-6"
              :model="forgotPasswordForm"
              ref="forgotPasswordForm"
              :rules="rules"
              label-width="80px"
              size="normal"
            >
              <el-form-item label="Email" prop="email">
                <el-input
                  name="email"
                  test-id="email"
                  placeholder="name@example.com"
                  type="email"
                  v-model="forgotPasswordForm.email"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="validateForgotPasswordForm('forgotPasswordForm')"
                  class="bg-primary px-4 lg:py-3.5 rounded-lg mt-5 mb-4 text-white text-xs lg:text-sm w-full font-normal"
                  test-id="button"
                  :loading="isLoading"
                >
                  {{
                    !isLoading ? 'Send recovery link' : 'Sending...'
                  }}</el-button
                >
              </el-form-item>
              <span
                class="font-medium flex text-primary text-sm justify-center cursor-pointer"
                test-id="signIn"
                @click="$router.push('login')"
                >Return to Sign in</span
              >
              <p class="flex justify-center text-sm mt-4 lg:text-normal">
                Don't have an account?
                <span
                  class="text-primary ml-1 cursor-pointer"
                  test-id="signUp"
                  @click="$router.push('sign-up')"
                  >Sign up</span
                >
              </p>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import tenant from '@/mixins/tenant.js'
export default {
  name: 'forgotPassword',
  mixins: [tenant],
  data () {
    return {
      breakpoints,
      rules: {
        email: [
          {
            required: true,
            type: 'email',
            message: 'Kindly enter a valid email.',
            trigger: ['blur', 'change']
          }
        ]
      },
      forgotPasswordForm: {
        email: ''
      },
      isLoading: false
    }
  },
  methods: {
    goBack () {
      this.$router.push('login')
    },
    validateForgotPasswordForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.getRecoveryLink()
        } else {
          this.$notify.error({
            title: 'Email required',
            message: 'Please enter your valid email',
            position: 'top-right'
          })
        }
      })
    },
    getRecoveryLink () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/forgotPassword', this.forgotPasswordForm.email)
        .then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Sent!',
            text: 'The password reset link has been sent to your email, kindly check',
            confirmButtonText: 'confirm',
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
          this.forgotPasswordForm.email = ''
          this.goBack()
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    AppAuthImage: () => import('@/assets/images/AppAuthImage.vue'),
    SymmetralIcon: () => import('@/assets/icons/SymmetralLogoIcon.vue')
  }
}
</script>

<style scoped>
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}
>>> .el-checkbox__inner:hover {
  border-color: var(--color-primary);
}
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item {
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  line-height: 25px;
}
>>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--color-primary);
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 48px;
}
>>> .el-card__body {
  padding: 10px;
}
</style>
